import { render } from "./AttandanceCheckBoxForm.vue?vue&type=template&id=35fbda8e&scoped=true"
import script from "./AttandanceCheckBoxForm.vue?vue&type=script&lang=js"
export * from "./AttandanceCheckBoxForm.vue?vue&type=script&lang=js"

import "./AttandanceCheckBoxForm.vue?vue&type=style&index=0&id=35fbda8e&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35fbda8e"]])

export default __exports__